module.exports = __webpack_public_path__ + "fonts/Poppins-Bold.e47421f9.otf";